import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Icon from '@material-ui/core/Icon';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import SubmitContentDetailScore, {makePrompt} from 'components/coaching/SubmitContentDetailScore';
import React from 'react';
import CoachingPlan from 'records/CoachingPlan';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';
import {makeStyles} from '@material-ui/core/styles';
import {QuestionIdentifier} from 'components/calls/components/sidebar/listening-assistant/QuestionIdentifier';

const useStyles = makeStyles(theme => ({
  accordionDetails: {
    display: 'unset',
    padding: '0px',
  },
  accordionRoot: {
    borderRadius: '3px',
    border: `1px solid ${theme.palette.divider}`,
    '&:before': {
      height: '0px',
    },
    margin: '5px 0',
  },
}));

interface Props {
  contentDetailScore: CoachingContentDetailScore;
  onQuestionExpandCollapse: (id: QuestionIdentifier | null) => void;
  onUpdateScore: (score: CoachingContentDetailScore) => void;
  expanded: boolean;
  plan: CoachingPlan;
  reasonSchemes: any;
  scoringSchemeMap: any;
  questionMap: any;
  inProgress: boolean;
}

export const AccordionQuestion: React.FC<Props> = ({
  contentDetailScore,
  onQuestionExpandCollapse,
  onUpdateScore,
  expanded,
  plan,
  reasonSchemes,
  scoringSchemeMap,
  questionMap,
  inProgress,
}) => {
  const question = questionMap.get(contentDetailScore.scorecardQuestionId);
  const prompt = makePrompt(
    question,
    contentDetailScore,
    contentDetailScore.contentDetail.skillName,
    plan.recipient.info
  );

  const {accordionRoot, accordionDetails} = useStyles();

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) =>
        onQuestionExpandCollapse(
          isExpanded
            ? {
                contentDetailId: contentDetailScore.contentDetailId,
                scorecardQuestionId: contentDetailScore.scorecardQuestionId,
              }
            : null
        )
      }
      classes={{root: accordionRoot}}>
      <AccordionSummary expandIcon={<Icon>expand_more</Icon>}>
        <span>{prompt}</span>
      </AccordionSummary>
      <AccordionDetails className={accordionDetails}>
        <SubmitContentDetailScore
          reasonSchemes={reasonSchemes}
          otherUser={plan.recipient}
          contentDetailScore={contentDetailScore}
          disabled={!inProgress}
          onChange={onUpdateScore}
          questionMap={questionMap}
          scoringSchemeMap={scoringSchemeMap}
          isCoach
          summary
        />
      </AccordionDetails>
    </Accordion>
  );
};
